const SIGNATURES = {
  "image/png": [[0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]],
  "image/jpeg": [[0xff, 0xd8, 0xff]],
  "application/pdf": [[0x25, 0x50, 0x44, 0x46, 0x2d]],
};

function normalizeMimeType(mimeType) {
  if (typeof mimeType !== "string") return "";
  const t = mimeType.trim().toLowerCase();
  if (t === "image/jpg") return "image/jpeg";
  return t;
}

function matchesAtOffset(bytes, signature, offset = 0) {
  if (bytes.length < offset + signature.length) return false;
  for (let i = 0; i < signature.length; i += 1) {
    if (bytes[offset + i] !== signature[i]) return false;
  }
  return true;
}

async function detectMimeTypeFromSignature(file) {
  const headBuffer = await file.slice(0, 16).arrayBuffer();
  const headBytes = new Uint8Array(headBuffer);

  if (SIGNATURES["image/png"].some((sig) => matchesAtOffset(headBytes, sig))) {
    return "image/png";
  }
  if (SIGNATURES["image/jpeg"].some((sig) => matchesAtOffset(headBytes, sig))) {
    return "image/jpeg";
  }
  if (SIGNATURES["application/pdf"].some((sig) => matchesAtOffset(headBytes, sig))) {
    return "application/pdf";
  }
  return "";
}

export async function validateFileByMimeAndSignature(file, allowedMimeTypes) {
  if (!file) {
    return { ok: false, message: "File non valido." };
  }

  const allowed = new Set((allowedMimeTypes ?? []).map(normalizeMimeType));
  const declaredType = normalizeMimeType(file.type);
  if (!allowed.has(declaredType)) {
    return { ok: false, message: "Il file non corrisponde ad un tipo accettato." };
  }

  const detectedType = await detectMimeTypeFromSignature(file);
  if (!detectedType) {
    return { ok: false, message: "Il file non corrisponde ad un tipo accettato." };
  }
  if (!allowed.has(detectedType) || detectedType !== declaredType) {
    return { ok: false, message: "Il file non corrisponde ad un tipo accettato." };
  }

  return { ok: true, mimeType: detectedType };
}

